import React from 'react';

const GLOBALMEDIATheme = {
  headerLogo: {
    src: '/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png',
    alt: 'Global Media',
  },
  darkLogo: {
    src: '/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png',
    alt: 'Global Media',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #474648',
  },
  linkStyle: {
    color: '#474648',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Global Media',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png" alt="Global Media" />
    </div>
  ),
  shareSite: 'https://reports.global-media.gr',
  organisationId: '424c25b6-f3fa-479a-b159-6fc7d6edde31',
};

export default GLOBALMEDIATheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/globalMedia.js
 **/